import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Row,
  Col,
  Container,
  Card,
  CardBody,
} from "react-bootstrap";
import axiosInstance from "Services/axiosInstance";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CandidateApprovalStatus from "./CandidateApprovalStatus";
import DataTable from "react-data-table-component";
import { BsPencilSquare, BsTrash } from "react-icons/bs";

const SetApproveScreen = () => {
  const [approvers, setApprovers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [step, setStep] = useState(1);
  const [loadingClient, setLoadingClient] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewApproversData, setViewApproversData] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);

  console.log(viewApproversData, "dada");
  const [dropdownOptions, setDropdownOptions] = useState({
    requisition_id: [],
    plan_id: [],
  });

  const fetchDropdownData = async () => {
    try {
      const res = await axiosInstance.get(
        "https://api.pixeladvant.com/design_screen_list_data/"
      );
      if (res.data.success) {
        setDropdownOptions({
          requisition_id: res.data.data.requisition_id || [],
          plan_id: res.data.data.plan_id || [],
        });
      } else {
        toast.error(res.data.message || "Failed to load dropdown data.");
      }
    } catch (error) {
      console.error("Dropdown fetch error:", error);
      toast.error("Failed to fetch dropdown data.");
    }
  };

  useEffect(() => {
    fetchApprovers();
    fetchDropdownData();
  }, [showEditModal]);

  const fetchClientDetails = async (req_id, plan_id) => {
    if (!req_id ) return;
    setLoadingClient(true);

    try {
      const res = await axiosInstance.post(
        "https://api.pixeladvant.com/api/client-lookup/",
        {
          req_id,
          plan_id,
        }
      );

      if (res.data.success) {
        const { client_name, client_id } = res.data.data;
        setFormState((prev) => ({
          ...prev,
          client_name,
          client_id,
        }));
      } else {
        toast.error(res.data.message || "Failed to retrieve client details.");
      }
    } catch (err) {
      console.error("Error fetching client data:", err);
      toast.error("Error fetching client information.");
    } finally {
      setLoadingClient(false);
    }
  };

  const [formState, setFormState] = useState({
    req_id: "",
    planning_id: "",
    client_name: "",
    client_id: "",
    no_of_approvers: 1,
    approvers: [
      {
        role: "",
        job_title: "",
        first_name: "",
        last_name: "",
        email: "",
        contact_number: "",
        set_as_approver: "Yes",
      },
    ],
  });

 const fetchApprovers = async () => {
  try {
    const res = await axiosInstance.get("/api/set-approver/");
    const requisitionGroups = res?.data?.data;

    if (res.data.success && Array.isArray(requisitionGroups)) {
      const formattedGroups = requisitionGroups.map((group) => ({
        req_id: group?.req_id,
        planning_id: group?.planning_id,
        client_name: group?.client_name,
        client_id: group?.client_id,
        no_of_approvers: group?.no_of_approvers,
        approvers: Array.isArray(group?.approvers) ? group.approvers : [],
      }));

      setViewApproversData(formattedGroups);
      setApprovers(formattedGroups); 
    } else {
      setViewApproversData([]);
      console.warn("Approvers list is invalid:", requisitionGroups);
    }
  } catch (error) {
    console.error("Error fetching approvers:", error);
    toast.error("Error fetching approvers.");
  }
};

  useEffect(() => {
    fetchApprovers();
  }, []);

  const handleMainChange = (e) => {
    const { name, value } = e.target;
    const updatedState = { ...formState, [name]: value };
    setFormState(updatedState);

    if (
      (name === "req_id" && updatedState.req_id) 
      // (name === "planning_id" && updatedState.req_id)
    ) {
      fetchClientDetails(
        name === "req_id" ? value : updatedState.req_id,
        // name === "planning_id" ? value : updatedState.planning_id
      );
    }
  };

  const handleApproverChange = (index, e) => {
    const { name, value } = e.target;
    const updatedApprovers = [...formState.approvers];
    updatedApprovers[index][name] = value;
    setFormState({ ...formState, approvers: updatedApprovers });
  };

  const handleNoOfApproversChange = (e) => {
    const count = parseInt(e.target.value, 10);
    const updatedApprovers = Array.from(
      { length: count },
      (_, i) =>
        formState.approvers[i] || {
          role: "",
          job_title: "",
          first_name: "",
          last_name: "",
          email: "",
          contact_number: "",
          set_as_approver: "Yes",
        }
    );
    setFormState({
      ...formState,
      no_of_approvers: count,
      approvers: updatedApprovers,
    });
  };

  const handleAddNew = () => {
    setFormState({
      req_id: "",
      planning_id: "",
      client_name: "",
      client_id: "",
      no_of_approvers: 1,
      approvers: [
        {
          role: "",
          job_title: "",
          first_name: "",
          last_name: "",
          email: "",
          contact_number: "",
          set_as_approver: "Yes",
        },
      ],
    });
    setStep(1);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setStep(1);
  };

  const addApproverRow = () => {
    setFormState((prev) => ({
      ...prev,
      approvers: [
        ...prev.approvers,
        {
          role: "",
          job_title: "",
          first_name: "",
          last_name: "",
          email: "",
          contact_number: "",
          set_as_approver: "Yes",
        },
      ],
    }));
  };
  
  const removeApproverRow = (index) => {
    setFormState((prev) => ({
      ...prev,
      approvers: prev.approvers.filter((_, i) => i !== index),
    }));
  };
  

  const handleFinalSubmit = async () => {
    try {
      const res = await axiosInstance.post("/api/set-approver/", formState);
      if (res.data.success) {
        toast.success("Approvers added successfully!");
        handleCloseModal();
        fetchApprovers();
      } else {
        toast.error(res.data.message || "Failed to submit approvers.");
      }
    } catch (err) {
      console.error("Final submit error:", err);
      toast.error("Submission failed.");
    }
  };

  const handleEdit = async (req_id) => {
    try {
      const res = await axiosInstance.post("/api/approvers/by-requisition/", {
        req_id,
      });
      if (res.data.success) {
        setShowEditModal(true);
        setFormState(res?.data?.data);
      } else {
        toast.error(res.data.message || "Failed to submit approvers.");
      }
    } catch (err) {
      console.error("Final submit error:", err);
      toast.error("Submission failed.");
    }
  };

  const handleUpdate = async () => {
    try {
      const res = await axiosInstance.put("/api/set-approver/", formState);
      if (res.data.success) {
        toast.success("Approvers Updated successfully!");
        setShowEditModal(false);
        fetchApprovers();
      } else {
        toast.error(res.data.message || "Failed to submit approvers.");
      }
    } catch (err) {
      console.error("Final submit error:", err);
      toast.error("Submission failed.");
    }
  };

  const handleDelete = async (row) => {
    console.log(row,"dadq")

    try {
      const res = await axiosInstance.delete(
        "https://api.pixeladvant.com/api/set-approver/",
        {
          data: {
            id: row?.approver_id,
          },
        }
      );
      if (res.data.success) {
        fetchApprovers();
        setViewApproversData([])
        toast.success("Approvers Deleted successfully!");
        setShowViewModal(false)
      } else {
        toast.error(res.data.message || "Failed to submit approvers.");
      }
    } catch (err) {
      console.error("Final submit error:", err);
      toast.error("Submission failed.");
    }
  };

    const columns = [
    {
      name: "Req ID",
      selector: row => row.req_id,
      sortable: true,
      center: true,
    },
    {
      name: "Planning ID",
      selector: row => row.planning_id,
      sortable: true,
      center: true,
    },
    {
      name: "Client Name",
      selector: row => row.client_name,
      sortable: true,
      center: true,
    },
    {
      name: "No. of Approver",
      selector: row => row.no_of_approvers,
      sortable: true,
      center: true,
    },
    {
      name: "Action",
      cell: row => (
        <div className="d-flex gap-1 justify-content-center">
          <Button
            size="sm"
            variant="outline-primary"
            onClick={() => {
              setViewApproversData(row.approvers || []);
              setShowViewModal(true);
            }}
          >
            View
          </Button>
          <Button
            size="sm"
            variant="outline-secondary"
            onClick={() => handleEdit(row.req_id)}
          >
            <BsPencilSquare className="me-1" />
          </Button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      center: true,
    }
  ];

       const tableStyles = {
  header: {
    style: {
      fontSize: '18px',
      fontWeight: '600',
      padding: '16px',
    },
  },
  headRow: {
    style: {
      backgroundColor: "linear-gradient(135deg, #0F172A 0%, #374151 100%)", // dark slate header
      borderBottomWidth: '2px',
      borderBottomColor: '#CBD5E1',
      borderBottomStyle: 'solid',
    },
  },
  headCells: {
    style: {
      fontSize: '15px',
      fontWeight: '700',
      color: '#F9FAFB', // light text
      padding: '14px 12px',
      letterSpacing: '0.3px',
      whiteSpace: 'normal',   // 👈 prevents cutting off
      wordBreak: 'break-word' // 👈 wraps long text
    },
  },
  rows: {
    style: {
      minHeight: '52px',
      fontSize: '14px',
      fontWeight: '500',
      '&:nth-of-type(odd)': {
        backgroundColor: '#F9FAFB', // zebra striping
      },
      '&:hover': {
        backgroundColor: '#E0F2FE  ', // light hover
        cursor: 'pointer',
      },
    },
  },
  cells: {
    style: {
      padding: '12px',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    },
  },
};


  return (
    <div>
      <Container fluid className="py-4 px-md-5 bg-light">
        <Card className="shadow-sm p-4">
          <div>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="fw-bold m-0">Approver Details</h5>
              <Button variant="success" onClick={handleAddNew}>
                + Add Approver
              </Button>
            </div>

            {/* <CandidateApprovalStatus /> */}
          </div>
          {/* <div className="table-responsive">
            <Table
              striped
              bordered
              hover
              size="sm"
              className="text-center align-middle"
            >
              <thead className="bg-primary text-white">
                <tr>
                  <th>Req ID</th>
                  <th>Planning ID</th>
                  <th>Client Name</th>
                  <th>No. of Approver</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {approvers.map((a, i) => (
                  <tr key={i}>
                    <td>{a.req_id}</td>
                    <td>{a.planning_id}</td>
                    <td>{a.client_name}</td>
                    <td>{a.no_of_approvers}</td>
                    <td className="d-flex p-2 gap-2 justify-content-center">
                      <Button
                        size="sm"
                        variant="outline-primary"
                        onClick={() => {
                          setViewApproversData(a.approvers || []);
                          setShowViewModal(true);
                        }}
                      >
                        View
                      </Button>
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => handleEdit(a.req_id)}
                      >
                        <BsPencilSquare className="me-1" />
                      </Button>

                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div> */}
          <DataTable
            // title="Approvers List"
            columns={columns}
            data={approvers || []}
            striped
            dense
            persistTableHead
            // progressPending={loading}
            customStyles={tableStyles}
            defaultSortField="req_id"
          />
        </Card>
        {/* <hr /> */}

        {/* <div>
          <CandidateApprovalStatus />
        </div>

        {/* Modal */}
        <Modal show={showModal} onHide={handleCloseModal} centered size="xl">
          <Modal.Header closeButton>
            <Modal.Title>Set Approver</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {step === 1 && (
              <>
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Planning ID</Form.Label>
                      <Form.Select
                        name="planning_id"
                        value={formState.planning_id}
                        onChange={handleMainChange}
                      >
                        <option value="">-- Select Planning ID --</option>
                        {dropdownOptions.plan_id.map((id, index) => (
                          <option key={index} value={id}>
                            {id}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Req ID</Form.Label>
                      <Form.Select
                        name="req_id"
                        value={formState.req_id}
                        onChange={handleMainChange}
                      >
                        <option value="">-- Select Req ID --</option>
                        {dropdownOptions.requisition_id.map((id, index) => (
                          <option key={index} value={id}>
                            {id}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <div className="text-end">
                  {loadingClient ? (
                    <Button variant="primary" disabled>
                      Loading...
                    </Button>
                  ) : (
                    formState.req_id &&
                    // formState.planning_id &&
                    formState.client_name &&
                    formState.client_id && (
                      <Button variant="primary" onClick={() => setStep(2)}>
                        Next
                      </Button>
                    )
                  )}
                </div>
              </>
            )}

            {step === 2 && (
              <>
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Client Name</Form.Label>
                      <Form.Control
                        name="client_name"
                        placeholder="Enter Client Name"
                        value={formState.client_name}
                        onChange={handleMainChange}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Client ID</Form.Label>
                      <Form.Control
                        name="client_id"
                        placeholder="Enter Client ID"
                        value={formState.client_id}
                        onChange={handleMainChange}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Table bordered hover responsive>
                  <thead className="table-light">
                    <tr>
                      <th>Role</th>
                      <th>Job Title</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Contact Number</th>
                      {/* <th>Set as Approver</th> */}
                      <th style={{ width: "150px" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formState.approvers.map((approver, index) => (
                      <tr key={index}>
                        <td>
                          <Form.Select
                            name="role"
                            value={approver.role}
                            onChange={(e) => handleApproverChange(index, e)}
                          >
                            <option value="">-- Select Role --</option>
                            <option value="Manager">Manager</option>
                            <option value="HR">HR</option>
                            <option value="HM">HM</option>
                            <option value="Finance">Finance</option>
                            <option value="Reviewer">Reviewer</option>
                          </Form.Select>
                        </td>
                        <td>
                          <Form.Control
                            name="job_title"
                            placeholder="Enter job title"
                            value={approver.job_title}
                            onChange={(e) => handleApproverChange(index, e)}
                          />
                        </td>
                        <td>
                          <Form.Control
                            name="first_name"
                            placeholder="Enter first name"
                            value={approver.first_name}
                            onChange={(e) => handleApproverChange(index, e)}
                          />
                        </td>
                        <td>
                          <Form.Control
                            name="last_name"
                            placeholder="Enter last name"
                            value={approver.last_name}
                            onChange={(e) => handleApproverChange(index, e)}
                          />
                        </td>
                        <td>
                          <Form.Control
                            type="email"
                            name="email"
                            placeholder="Enter email"
                            value={approver.email}
                            onChange={(e) => handleApproverChange(index, e)}
                          />
                        </td>
                        <td>
                          <Form.Control
                            name="contact_number"
                            placeholder="Enter contact number"
                            value={approver.contact_number}
                            onChange={(e) => handleApproverChange(index, e)}
                          />
                        </td>
                        {/* <td>
                  <Form.Select
                    name="set_as_approver"
                    value={approver.set_as_approver}
                    onChange={(e) => handleApproverChange(index, e)}
                  >
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Select>
                </td> */}
                        <td className="text-center">
                          {formState.approvers.length > 1 && (
                            <Button
                              variant="outline-danger"
                              size="sm"
                              className="me-2"
                              onClick={() => removeApproverRow(index)}
                            >
                              Remove
                            </Button>
                          )}
                          {index === formState.approvers.length - 1 && (
                            <Button
                              variant="outline-success"
                              size="sm"
                              onClick={addApproverRow}
                            >
                              Add
                            </Button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Cancel
            </Button>
            {step === 2 && (
              <Button variant="success" onClick={handleFinalSubmit}>
                Submit
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        {/* editmodal */}
        <Modal
          show={showEditModal}
          onHide={() => setShowEditModal(false)}
          centered
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Set Approver</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Client Name</Form.Label>
                  <Form.Control
                    name="client_name"
                    placeholder="Enter client name"
                    value={formState.client_name}
                    onChange={handleMainChange}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Client ID</Form.Label>
                  <Form.Control
                    name="client_id"
                    placeholder="Enter client ID"
                    value={formState.client_id}
                    onChange={handleMainChange}
                    disabled
                  />
                </Form.Group>
              </Col>
            </Row>

            <Table bordered hover responsive>
              <thead className="table-light">
                <tr>
                  <th>Role</th>
                  <th>Job Title</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Contact Number</th>
                  {/* <th>Set as Approver</th> */}
                  <th style={{ width: "150px" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {formState.approvers.map((approver, index) => (
                  <tr key={index}>
                    <td>
                      <Form.Select
                        name="role"
                        value={approver.role}
                        onChange={(e) => handleApproverChange(index, e)}
                      >
                        <option value="">-- Select Role --</option>
                        <option value="Manager">Manager</option>
                        <option value="HR">HR</option>
                        <option value="HM">HM</option>
                        <option value="Finance">Finance</option>
                        <option value="Reviewer">Reviewer</option>
                      </Form.Select>
                    </td>
                    <td>
                      <Form.Control
                        name="job_title"
                        placeholder="Enter job title"
                        value={approver.job_title}
                        onChange={(e) => handleApproverChange(index, e)}
                      />
                    </td>
                    <td>
                      <Form.Control
                        name="first_name"
                        placeholder="Enter first name"
                        value={approver.first_name}
                        onChange={(e) => handleApproverChange(index, e)}
                      />
                    </td>
                    <td>
                      <Form.Control
                        name="last_name"
                        placeholder="Enter last name"
                        value={approver.last_name}
                        onChange={(e) => handleApproverChange(index, e)}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Enter email"
                        value={approver.email}
                        onChange={(e) => handleApproverChange(index, e)}
                      />
                    </td>
                    <td>
                      <Form.Control
                        name="contact_number"
                        placeholder="Enter contact number"
                        value={approver.contact_number}
                        onChange={(e) => handleApproverChange(index, e)}
                      />
                    </td>
                    {/* <td>
                  <Form.Select
                    name="set_as_approver"
                    value={approver.set_as_approver}
                    onChange={(e) => handleApproverChange(index, e)}
                  >
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Select>
                </td> */}
                    <td className="text-center">
                      {formState.approvers.length > 1 && (
                        <Button
                          variant="outline-danger"
                          size="sm"
                          className="me-2"
                          onClick={() => removeApproverRow(index)}
                        >
                          Remove
                        </Button>
                      )}
                      {index === formState.approvers.length - 1 && (
                        <Button
                          variant="outline-success"
                          size="sm"
                          onClick={addApproverRow}
                        >
                          Add
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              Cancel
            </Button>

            <Button variant="success" onClick={handleUpdate}>
              update
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showViewModal}
          onHide={() => setShowViewModal(false)}
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Approver Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <DataTable
              columns={[
                { name: "Role", selector: (row) => row.role, sortable: true },
                { name: "Job Title", selector: (row) => row.job_title },
                { name: "First Name", selector: (row) => row.first_name },
                { name: "Last Name", selector: (row) => row.last_name },
                { name: "Email", selector: (row) => row.email },
                { name: "Contact", selector: (row) => row.contact_number },
                { name: "Approver", selector: (row) => row.set_as_approver },
                {
                  name: "Action",
                  cell: (row) => (
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => handleDelete(row)}
                    >
                      <BsTrash className="me-1" />
                    </Button>
                  ),
                  ignoreRowClick: true,
                  allowOverflow: true,
                  button: true,
                },
              ]}
              data={viewApproversData}
              // pagination
              // highlightOnHover
              // striped
              responsive
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowViewModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* edit */}

        {/* <Modal
          show={showEditModal}
          onHide={() => setShowEditModal(false)}
          centered
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Approver</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Client Name</Form.Label>
                    <Form.Control
                      name="client_name"
                      placeholder="Enter client name"
                      value={formState.client_name}
                      onChange={handleMainChange}
                      disabled
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Client ID</Form.Label>
                    <Form.Control
                      name="client_id"
                      placeholder="Enter client ID"
                      value={formState.client_id}
                      onChange={handleMainChange}
                      disabled
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>Number of Approvers</Form.Label>
                <Form.Control
                  type="number"
                  min="1"
                  name="no_of_approvers"
                  value={formState.no_of_approvers}
                  onChange={handleNoOfApproversChange}
                />
              </Form.Group>

              {formState.approvers.map((approver, index) => (
                <div key={index} className="border rounded p-3 mb-4">
                  <h6 className="fw-bold">Approver {index + 1}</h6>
                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Role</Form.Label>
                        <Form.Select
                          name="role"
                          value={approver.role}
                          onChange={(e) => handleApproverChange(index, e)}
                        >
                          <option value="">-- Select Role --</option>
                          <option value="MANAGER">Manager</option>
                          <option value="HR">HR</option>
                          <option value="FINANCE">Finance</option>
                          <option value="REVIEWER">Reviewer</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Job Title</Form.Label>
                        <Form.Control
                          name="job_title"
                          value={approver.job_title}
                          onChange={(e) => handleApproverChange(index, e)}
                          placeholder="Enter job title"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>First Name</Form.Label>
                        <Form.Control
                          name="first_name"
                          value={approver.first_name}
                          onChange={(e) => handleApproverChange(index, e)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Last Name</Form.Label>
                        <Form.Control
                          name="last_name"
                          value={approver.last_name}
                          onChange={(e) => handleApproverChange(index, e)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={approver.email}
                          onChange={(e) => handleApproverChange(index, e)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Contact Number</Form.Label>
                        <Form.Control
                          name="contact_number"
                          value={approver.contact_number}
                          onChange={(e) => handleApproverChange(index, e)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group>
                    <Form.Label>Set as Approver</Form.Label>
                    <Form.Select
                      name="set_as_approver"
                      value={approver.set_as_approver}
                      onChange={(e) => handleApproverChange(index, e)}
                    >
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>
                </div>
              ))}
            </>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              Cancel
            </Button>
            <Button variant="success" onClick={handleUpdate}>
              Update
            </Button>
          </Modal.Footer>
        </Modal> */}

        <ToastContainer position="top-right" autoClose={3000} />
      </Container>
    </div>
  );
};

export default SetApproveScreen;
